import React, { useEffect, useState } from 'react';
import ContactForm from './ContactForm.jsx';

export default function BlogContact({ articleTitle }) {
  const [open, setOpen] = useState(false);
  const panelId = 'blog-contact-panel';

  useEffect(() => {
    if (!open) return undefined;
    const onKeyDown = (event) => {
      if (event.key === 'Escape') setOpen(false);
    };
    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [open]);

  return (
    <div className="blog-contact">
      <button
        type="button"
        className="blog-contact-toggle"
        aria-expanded={open}
        aria-controls={panelId}
        onClick={() => setOpen((value) => !value)}
      >
        Thoughts? Hit me up
      </button>
      {open && (
        <div className="blog-contact-panel" id={panelId}>
          <ContactForm
            compact
            autoFocusMessage
            idPrefix="blog-contact"
            messagePrefix={`Re: ${articleTitle}`}
          />
        </div>
      )}
    </div>
  );
}
